import { type ActionEvent, Controller } from "@hotwired/stimulus"

import { renderTurboStream } from "@/helpers/turbo"
import WishlistController from "./wishlist_controller"
import LoaderController from "./loader_controller"

export default class WishlistPageController extends Controller {
  static outlets = ["loader", "wishlist"]
  declare readonly loaderOutlet: LoaderController
  declare readonly wishlistOutlet: WishlistController

  static targets = ["emptyResult", "venueCard"]
  declare readonly emptyResultTarget: HTMLElement
  declare readonly venueCardTargets: HTMLElement[]

  connect(): void {
    void this.renderCards()
  }

  removeCard({ params: { id } }: ActionEvent): void {
    this.venueCardTargets.find((venueCard) => venueCard.dataset.id === id.toString())?.remove()

    if (!this.venueCardTargets.length) {
      this.emptyResultTarget.hidden = false
    }
  }

  private async renderCards(): Promise<void> {
    const items = Object.values(this.wishlistOutlet.wishlist).reverse()

    if (!items.length) {
      this.emptyResultTarget.hidden = false
      return
    }

    this.loaderOutlet.startWithId(this.identifier)
    this.emptyResultTarget.hidden = true

    try {
      await renderTurboStream("/wishlist/render_cards", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token":
            document.querySelector<HTMLMetaElement>("meta[name=csrf-token]")?.content || ""
        },
        body: JSON.stringify({ items })
      })
    } finally {
      this.loaderOutlet.stop()
    }
  }
}
